import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CLink, CSidebarBrand, CCol,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";

// routes config
import routes from "../routes";

import {
  TheHeaderDropdown,
  TheHeaderDropdownMssg,
  TheHeaderDropdownNotif,
  TheHeaderDropdownTasks,
} from "./index";
import Users from "../models/Users";

const TheHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);

  const [user, setUser] = useState({})

  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    dispatch({ type: "set", sidebarShow: val });
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    dispatch({ type: "set", sidebarShow: val });
  };

  useEffect(()=>{
    getData()
  },[])

  const getData = async() =>{
    let userModel = new Users()

    let users = await userModel.getLoggedInUser()

    let user = users[0]
    setUser(user)


  }

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        <img
          className="c-sidebar-brand-full"
          height={35}
          style={{
            padding : 5
          }}
          src={require("../assets/icons/long-logo.svg")}/>
        {/*<CIcon name="logo" height="48" alt="Logo" />*/}
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3">
          {/*<CHeaderNavLink to="/dashboard">Dashboard</CHeaderNavLink>*/}
        </CHeaderNavItem>
        {/* <CHeaderNavItem  className="px-3">
          <CHeaderNavLink to="/users">Users</CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem className="px-3">
          <CHeaderNavLink>Settings</CHeaderNavLink>
        </CHeaderNavItem> */}
      </CHeaderNav>

      <CHeaderNav
        style={{
          display : "flex",
          flexDirection : "column",
        }}
        className="px-3">
        <CCol style={{
          padding : 10
        }}>
          <div style={{width : "100%", textAlign :"right"}}>
            Hai, {user.full_name}
          </div>
          <div style={{width : "100%", textAlign :"right"}}>
            <small>{user.branch} | {user.position}</small>
          </div>
        </CCol>

      </CHeaderNav>

      {/*<CSubheader className="px-3 justify-content-between">*/}
      {/*  <CBreadcrumbRouter*/}
      {/*    className="border-0 c-subheader-nav m-0 px-0 px-md-3"*/}
      {/*    routes={routes}*/}
      {/*  />*/}
      {/*  <div className="d-md-down-none mfe-2 c-subheader-nav">*/}
      {/*  </div>*/}
      {/*</CSubheader>*/}
    </CHeader>
  );
};

export default TheHeader;
